import React, { useState, useEffect, useCallback } from 'react';
import './LogoSlider.css';

interface LogoSliderProps {
  title?: string;
  subtitle?: string;
}

const LogoSlider: React.FC<LogoSliderProps> = ({ title, subtitle }) => {
  const [logos, setLogos] = useState<string[]>([]);

  // Function to generate logo list using actual logos in the folder
  const generateLogoList = useCallback(() => {
    if (title && title.includes('Partner')) {
      // Partner logos for the partners section
      const partnerLogos = [
        '677c3eff95aa469f00a073d3_MKReferenzenMicro.svg',
        '677c41d92827c4a0613dc315_MKReferenzenMicro2.svg',
        '677c3c765de429e588c006be_MKReferenzenMicro_43.svg',
        '677c3ca294ae194a3958b497_MKReferenzenMicro_41.svg',
        '677c3cc54783aca910993ffe_MKReferenzenMicro_45.svg',
        '677c3d0cca4bf313ae1b53a7_MKReferenzenMicro_40.svg',
        '677c3d3fd66c7e3c00fed281_MKReferenzenMicro_42.svg',
        '677c3eda3c852d0e6a90f9ee_MKReferenzenMicro_44.svg',
        '677c3f7e401537b9df8ba851_MKReferenzenMicro_39.svg',
        '677c3f408269af3745656206_MKReferenzenMicro_38.svg',
        '66a78bcbbba39f948ee6418a_MKReferenzenIhkduesseldorf.svg'
      ];
      return partnerLogos;
    }
    
    // Default home logos for other sections
    const actualLogos = [
      'mintkitchen_home_logos_1.svg',
      'mintkitchen_home_logos_2.svg',
      'mintkitchen_home_logos_3.svg',
      'mintkitchen_home_logos_4.svg',
      'mintkitchen_home_logos_5.svg',
      'mintkitchen_home_logos_6.svg',
      'mintkitchen_home_logos_7.svg',
      'mintkitchen_home_logos_8.svg',
      'mintkitchen_home_logos_9.svg',
      'mintkitchen_home_logos_10.svg',
      'mintkitchen_home_logos_11.svg',
      'mintkitchen_home_logos_12.svg',
      'mintkitchen_home_logos_13.svg',
      'mintkitchen_home_logos_14.svg',
      'mintkitchen_home_logos_15.svg',
      'mintkitchen_home_logos_16.svg',
      'mintkitchen_home_logos_17.svg',
      'mintkitchen_home_logos_18.svg',
      'mintkitchen_home_logos_19.svg',
      'mintkitchen_home_logos_20.svg',
      'mintkitchen_home_logos21.svg'
    ];
    
    return actualLogos;
  }, [title]);

  useEffect(() => {
    setLogos(generateLogoList());
  }, [generateLogoList]);

  // Duplicate the logos for infinite scroll effect
  const duplicatedLogos = [...logos, ...logos];

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.src = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjgwIiB2aWV3Qm94PSIwIDAgMTIwIDgwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTIwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjRjVGNUY1IiBzdHJva2U9IiNFMEUwRTAiLz4KPHR5cGU+TG9nbzwvdHlwZT4KPC9zdmc+`;
    target.alt = 'Logo Placeholder';
  };

  return (
    <section className={`logo-slider-section ${title ? 'with-header' : ''}`} data-section="logo-slider">
      <div className="logo-slider-container">
        {title && (
          <div className="logo-slider-header">
            <h2>{title.includes('Partner') ? (
              <>Einige unserer regionalen <span className="highlight-text">Partner</span></>
            ) : title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
        )}
        <div className="logo-slider-track">
          {duplicatedLogos.map((logo, index) => (
            <div key={index} className="logo-item">
              <img
                src={title && title.includes('Partner') 
                  ? `/assets/images/ki-kurse/partners/${logo}`
                  : `/assets/images/home/logos/${logo}`
                }
                alt={title && title.includes('Partner') 
                  ? `Partner Logo ${index + 1}`
                  : `Customer Logo ${index + 1}`
                }
                className="logo-image"
                onError={handleImageError}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoSlider;
